import { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import GlobalState from "../contexts/GlobalState";
import Api from "./Api";
// import logo from '../images/earrel.svg';

const Layout = (props) => {
  const { generalDataGlobal, popup, setPopup, isOpen, setIsOpen } =
    useContext(GlobalState);
  const [generalDataApiOptions, setGeneralDataApiOptions] = useState({});
  const [error, setError] = useState();
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState("");

  const navigate = useNavigate();
  const { lang } = useParams(); 

  const toggleLanguage = () => {
    const new_lang = lang === "en" ? "ar" : "en";
    localStorage.setItem("language", new_lang);
    navigate(`/${new_lang}${window.location.pathname.substring(3)}`);
    window.location.reload();
  }

  useEffect(() => {
    console.log(subscribed);
  }, [subscribed]);

  const [active, setActive] = useState(0);
  const [popupHeight, setPopupHeight] = useState();

  // const handleTransition = () => {
  //   setPopupHeight(
  //     document.getElementsByClassName("terms-content")[0].clientHeight
  //   );
  //   document.getElementsByClassName("terms-content")[0].style.maxHeight =
  //     popupHeight;
  //   setActive(1);
  // };

  const handleCTA = (url) => {
    if (!url) return;

    const finalUrl = url.startsWith("www.") ? `https://${url}` : url;

    window.open(finalUrl, "_blank", "noopener,noreferrer");

    setPopup(false);
    sessionStorage.setItem("lta-first-visit", false);
  };

  useEffect(() => {
    if (isOpen) {
      document.querySelector("body").style.overflow = "hidden";
    } else {
      document.querySelector("body").style.overflow = "";
    }
  }, [isOpen]);

  useEffect(() => {
    if (popup) {
      document.querySelector("body").style.overflow = "hidden";
    } else {
      document.querySelector("body").style.overflow = "";
    }
  }, [popup]);

  useEffect(() => {
    setIsOpen(false);
    // eslint-disable-next-line
  }, []);

  const subscribe = (e) => {
    e.preventDefault();
    setGeneralDataApiOptions({
      url: "/newsletter",
      method: "post",
      data: {
        email: email,
      },
      callback: (res) => {
        setEmail("");
        setSubscribed(res.data);
        console.log(res.data);

        setTimeout(() => {
          setSubscribed("");
        }, 3000);
      },
      catch422: (errors) => {
        setError(errors);
        setTimeout(() => {
          setError("");
        }, 3000);
      },
    });
  };

  return (
    <Fragment>
      <Api options={generalDataApiOptions} />

      <div className="section-space"></div>
      {/* desktop navbar */}
      <div className={"front-nav position-fixed shadow-custom"}>
        <div className="container">
          <nav className="d-flex justify-content-between ">
            <div className="logo">
              <Link to={`/${lang}`}>
                {/* <img src="/assets/images/earrel-logo.svg" alt="" /> */}
                <img
                  src={generalDataGlobal[0]?.general?.main_logo_path}
                  className="main-logo"
                  alt="main logo"
                />
              </Link>
            </div>
            <div className="menu-items position-relative ">
              <ul className="menu-list d-none d-md-block">
                <Link
                  to={`/${lang}/about`}
                  className={props.activePage === "about" ? "activePage" : ""}
                >
                  <li >{generalDataGlobal[0]?.menu_items["about"]}</li>
                </Link>

                <Link
                  to={`/${lang}/sectors`}
                  className={props.activePage === "sectors" ? "activePage" : ""}
                >
                  <li className="has-children-sectors">
                    {generalDataGlobal[0]?.menu_items["sectors"]}
                    <div className="sectors-list-container position-absolute">
                      <div className="sectors-list  d-flex flex-column align-items-center justify-content-center dropdown-shadow">
                        {generalDataGlobal[0]?.sectors_home.map(
                          (sector, index) => (
                            <div key={index} className="sector d-flex">
                              <Link className="d-flex w-100 justify-content-between" to={`/${lang}/sectors/${sector.slug}`}>
                                <p className={"single-sector-title "}>
                                  {sector.title}
                                </p>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24.001"
                                  height="12.587"
                                  viewBox="0 0 24.001 12.587"
                                  className="d-flex flex-shrink-0 "
                                  style={{transform: `rotate(${lang === 'en' ? '' : '180deg'})`}}
                                >
                                  <path
                                    d="M23.124,9.907,19.245,6.029a1,1,0,0,0-1.414,0h0a1,1,0,0,0,0,1.414L21.386,11H1a1,1,0,0,0-1,1H0a1,1,0,0,0,1,1H21.447l-3.616,3.615a1,1,0,0,0,0,1.415h0a1,1,0,0,0,1.414,0l3.88-3.879A3.008,3.008,0,0,0,23.124,9.907Z"
                                    transform="translate(0 -5.736)"
                                    fill={`${generalDataGlobal[0]?.general?.primary_color}`}
                                  />
                                </svg>
                              </Link>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </li>
                </Link>
                <Link to="" className={props.activePage === "tracker" || props.activePage === "tilb-tracker" ? "activePage" : ""}>
                <li className="has-children-library">
                    {generalDataGlobal[0]?.menu_items["tracker"]}
                    <div className="library-list-container position-absolute">
                      <div className="tracker-list  d-flex flex-column align-items-center justify-content-center dropdown-shadow">
                        {generalDataGlobal[0]?.tracker_list.map(
                          (item, index) => (
                            <div key={index} className="library d-flex ">
                              <Link className="d-flex w-100 justify-content-between" to={`/${lang}/${item.slug}`}>
                                <p className="single-sector-title">
                                  {item.title}
                                </p>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24.001"
                                  height="12.587"
                                  viewBox="0 0 24.001 12.587"
                                  className="d-flex flex-shrink-0"
                                  style={{transform: `rotate(${lang === 'en' ? '' : '180deg'})`}}
                                >
                                  <path
                                    d="M23.124,9.907,19.245,6.029a1,1,0,0,0-1.414,0h0a1,1,0,0,0,0,1.414L21.386,11H1a1,1,0,0,0-1,1H0a1,1,0,0,0,1,1H21.447l-3.616,3.615a1,1,0,0,0,0,1.415h0a1,1,0,0,0,1.414,0l3.88-3.879A3.008,3.008,0,0,0,23.124,9.907Z"
                                    transform="translate(0 -5.736)"
                                    fill={`${generalDataGlobal[0]?.general?.primary_color}`}
                                  />
                                </svg>
                              </Link>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </li>
                </Link>

                {/* <Link
                  to="/reports"
                  className={props.activePage === "reports" ? "activePage" : ""}
                >
                  <li>{generalDataGlobal[0]?.menu_items["reports"]}</li>
                </Link> */}
                {/* <Link
                  to={`/${lang}/library`}
                  className={props.activePage === "library" ? "activePage" : ""}
                >
                  <li className="has-children-library">
                    {generalDataGlobal[0]?.menu_items["library"]}
                    <div className="library-list-container position-absolute">
                      <div className="library-list  d-flex flex-column align-items-center justify-content-center dropdown-shadow">
                        {generalDataGlobal[0]?.library_home.map(
                          (library, index) => (
                            <div key={index} className="library d-flex">
                              <Link className="d-flex w-100 justify-content-between" to={`/${lang}/${library.slug}`}>
                                <p className="single-sector-title">
                                  {library.title}
                                </p>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24.001"
                                  height="12.587"
                                  viewBox="0 0 24.001 12.587"
                                  className="d-flex flex-shrink-0"
                                  style={{transform: `rotate(${lang === 'en' ? '' : '180deg'})`}}
                                >
                                  <path
                                    d="M23.124,9.907,19.245,6.029a1,1,0,0,0-1.414,0h0a1,1,0,0,0,0,1.414L21.386,11H1a1,1,0,0,0-1,1H0a1,1,0,0,0,1,1H21.447l-3.616,3.615a1,1,0,0,0,0,1.415h0a1,1,0,0,0,1.414,0l3.88-3.879A3.008,3.008,0,0,0,23.124,9.907Z"
                                    transform="translate(0 -5.736)"
                                    fill={`${generalDataGlobal[0]?.general?.primary_color}`}
                                  />
                                </svg>
                              </Link>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </li>
                </Link> */}

                <button onClick={toggleLanguage} className="language-toggle">
                  {lang === "en" ? "عربي" : "En"}
                </button>

              </ul>    

              <div
                className="d-block d-md-none menu-button"
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
              >
                <div className="d-flex align-items-center h-100">
                  <img
                    src={
                      "/assets/images/" +
                      (!isOpen ? "open-menu.svg" : "close-menu.svg")
                    }
                    alt=""
                  />
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>

      <div className={"popup-container" + (isOpen ? " show" : "")}>
        <div className="front-nav">
          <div className="container">
            <nav className="d-flex justify-content-between ">
              <div className="logo">
                <Link to={`/${lang}`}>
                  <img
                    src={generalDataGlobal[0]?.general?.main_logo_path}
                    className="main-logo"
                    alt="main logo"
                  />
                </Link>
              </div>
              <div
                className="d-block d-lg-none menu-button"
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
              >
                <div className="d-flex align-items-center h-100">
                  <img
                    src={
                      "/assets/images/" +
                      (!isOpen ? "open-menu.svg" : "close-menu.svg")
                    }
                    alt=""
                  />
                </div>
              </div>
            </nav>
          </div>
        </div>

        <div
          className={
            "mobile-menu position-relative d-flex flex-column align-items-center justify-content-center" +
            (isOpen ? " show" : "")
          }
        >
          <div className="img-container-bottom position-absolute w-100 h-100">
            <img
              src={generalDataGlobal[0]?.general.secondary_logo_path}
              alt="LAMP"
            />
          </div>
          <div className="menu-items-mobile-container position-relative">
            <div className="menu-items-mobile d-flex flex-column align-items-center">
              <Link
                to={`/${lang}/about`}
                className={props.activePage === "about" ? "activePage" : ""}
              >
                <p
                  className={"mobile-menu-category"}
                >
                  {generalDataGlobal[0]?.menu_items["about"]}
                </p>
              </Link>
              {/* <Link
                to={`/${lang}/library`}
                className={props.activePage === "library" ? "activePage" : ""}
              >
                <p className="mobile-menu-category">
                  {generalDataGlobal[0]?.menu_items["library"]}
                </p>
              </Link>

              <div
                className="  d-flex flex-column align-items-center justify-content-center"
                style={{ marginBottom: 30 }}
              >
                {generalDataGlobal[0]?.library_home.map((library, index) => (
                  <Link key={index} to={`/${lang}/${library.slug}`}>
                    <p className="single-sector-title mb-1 mobile-menu-subcategory">
                      {library.title}
                    </p>
                  </Link>
                ))}
              </div> */}
              <Link
                to={`/${lang}/sectors`}
                className={props.activePage === "sectors" ? "activePage" : ""}
              >
                <p className="mobile-menu-category mb-0">
                  {generalDataGlobal[0]?.menu_items["sectors"]}
                </p>
              </Link>

              {/* <div
                className="  d-flex flex-column align-items-center justify-content-center"
                style={{ marginBottom: 30 }}
              >
                {generalDataGlobal[0]?.sectors_home.map((sector, index) => (
                  <Link to={"/sectors/" + sector.slug} key={index}>
                    <p className="single-sector-title mb-1 mobile-menu-subcategory">
                      {sector.title}
                    </p>
                  </Link>
                ))}
              </div> */}
               <Link to="" className={`${props.activePage === "tracker" || props.activePage === "tilb-tracker" ? "activePage" : "" } pe-none`}>
                <p className="mobile-menu-category mt-3">
                  {generalDataGlobal[0]?.menu_items["tracker"]}
                </p>
              </Link>
              <div
                className="  d-flex flex-column align-items-center justify-content-center"
                style={{ marginBottom: 30 }}
              >
                {generalDataGlobal[0]?.tracker_list.map((item, index) => (
                  <Link key={index} to={`/${lang}/${item.slug}`}>
                    <p className="single-sector-title mb-1 mobile-menu-subcategory text-center">
                      {item.title}
                    </p>
                  </Link>
                ))}
              </div>

              <Link
                to={`/${lang}/reports`}
                className={props.activePage === "about" ? "activePage" : ""}
              >
                <p
                  className="mobile-menu-category"
                  style={{ }}
                >
                  {generalDataGlobal[0]?.menu_items["reports"]}
                </p>
              </Link>
             
              <button onClick={toggleLanguage} className="language-toggle d-flex align-items-center">
                <p className="text-center">{lang === "en" ? "عربي" : "En"}</p>
              </button>
            </div>
          </div>
        </div>
        <div className="container-fluid m-0">
          <div className="row buttons-row">
            <div className="col-4 p-0">
              <Link to={`/${lang}/contact-us`}>
                <button
                  className={`w-100 ${
                    props.activePage === "contact" ? "activePage" : ""
                  }`}
                >
                  {generalDataGlobal[0]?.footer_settings.contact}
                </button>
              </Link>
            </div>
            <div className="col-4 middle-button">
              <Link to={`/${lang}/disclaimer`}>
                <button
                  className={`w-100 ${
                    props.activePage === "disclaimer" ? "activePage" : ""
                  }`}
                >
                  {generalDataGlobal[0]?.footer_settings.Disclaimer}
                </button>
              </Link>
            </div>
            <div className="col-4 p-0">
              <Link to={`/${lang}/faq`}>
                <button
                  className={`w-100 ${
                    props.activePage === "faq" ? "activePage" : ""
                  }`}
                >
                  {generalDataGlobal[0]?.footer_settings.FAQ}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* content */}
      {props.children}

      {/* footer */}

      <div className="footer-section position-relative">
        <div className="container footer-content-container">
          <div className="row under-border">
            <div className="col-12 d-flex justify-content-center align-items-center turn-absolute d-md-none d-flex">
              <div className="middle-logo-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    generalDataGlobal[0]?.footer_settings.middle_logo
                  }
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-4 col-12">
              {/* <div className="images-container">
                <div className="row">
                  <div className="col-lg-6 trans">
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        generalDataGlobal[0]?.footer_settings.logo1
                      }
                      alt=""
                      className="me-4"
                    />
                  </div>
                  <div className="col-lg-6 trans">
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        generalDataGlobal[0]?.footer_settings.logo2
                      }
                      alt=""
                    />
                  </div>
                </div>
              </div> */}
              <div className="images-container">
                <div className="row flex-wrap align-items-center">
                  {generalDataGlobal[0]?.footer_logos.length ? (
                    generalDataGlobal[0]?.footer_logos.map((logo, index) => (
                      <div key={index} className="col-6 trans logos-col mb-3">
                        <img
                          src={logo.logo_path}
                          alt="footer logo"
                          className={`${index % 2 === 0 ? "me-3" : ""}`}
                        />
                      </div>
                    ))
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div className="excerpt-container">
                <p>{generalDataGlobal[0]?.footer_settings.excerpt}</p>
              </div>

              <div className="social-media d-flex mb-lg-4">
                <div className="icons-container d-flex">
                  {generalDataGlobal[0]?.social_media.map((icon, index) => (
                    <div key={index} className="icon-container me-4">
                      <a
                        href={icon.url}
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        <img
                          src={process.env.REACT_APP_BASE_URL + icon.icon}
                          alt=""
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-md-4 col-6 d-flex justify-content-center align-items-center turn-absolute d-none d-md-flex">
              <div className="middle-logo-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    generalDataGlobal[0]?.footer_settings.middle_logo
                  }
                  alt=""
                />
              </div>
            </div>

            <div className="col-lg-5 col-md-5 contact-footer d-md-none d-flex justify-content-between">
              <Link to={`/${lang}/contact-us`}>
                <p
                  className={`me-4 position-relative ${
                    props.activePage === "contact" ? "active" : ""
                  }`}
                >
                  {generalDataGlobal[0]?.footer_settings.contact}
                </p>
              </Link>

              <Link to={`/${lang}/disclaimer`}>
                <p
                  className={`me-4 position-relative ${
                    props.activePage === "disclaimer" ? "active" : ""
                  }`}
                >
                  {generalDataGlobal[0]?.footer_settings.Disclaimer}
                </p>
              </Link>

              <Link to={`/${lang}/faq`}>
                <p
                  className={`position-relative ${
                    props.activePage === "faq" ? "active" : ""
                  }`}
                >
                  {generalDataGlobal[0]?.footer_settings.FAQ}
                </p>
              </Link>
            </div>

            <div className="col-md-4 d-flex flex-column  col-letter">
              <div className="images-container pb-0">
                <div className="letter-title">
                  <p>
                    {generalDataGlobal[0]?.footer_settings.newsletter_title}
                  </p>
                </div>
              </div>

              <form
                onSubmit={subscribe}
                className="newsletter-form"
                id="newsletter-form"
              >
                <div className="letter-wrapper d-flex">
                  <input
                    className="flex-grow-1 custom-input"
                    type="email"
                    name="email"
                    placeholder={
                      generalDataGlobal[0]?.footer_settings.letter_palceholder
                    }
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                  <button
                    type="submit"
                    className="letter-button col-5 custom-button"
                  >
                    {" "}
                    {generalDataGlobal[0]?.footer_settings.subscribe}
                  </button>
                </div>
                {subscribed !== "" ? (
                  <p className="subscribed">{subscribed}</p>
                ) : error ? (
                  <p className="subscribed">{error.email}</p>
                ) : null}
              </form>
            </div>
          </div>
          <hr className="footer-hr" />

          <div className="row">
            <div className="col-lg-5 col-md-5 contact-footer d-none d-md-flex mt-4">
              <Link to={`/${lang}/contact-us`}>
                <p
                  className={`me-4 position-relative  ${
                    props.activePage === "contact" ? "active" : ""
                  }`}
                >
                  {generalDataGlobal[0]?.footer_settings.contact}
                </p>
              </Link>

              <Link to={`/${lang}/disclaimer`}>
                <p
                  className={`me-4 position-relative  ${
                    props.activePage === "disclaimer" ? "active" : ""
                  }`}
                >
                  {generalDataGlobal[0]?.footer_settings.Disclaimer}
                </p>
              </Link>

              <Link to={`/${lang}/faq`}>
                <p
                  className={`position-relative  ${
                    props.activePage === "faq" ? "active" : ""
                  }`}
                >
                  {generalDataGlobal[0]?.footer_settings.FAQ}
                </p>
              </Link>
            </div>
            <div className="col-lg-7 ">
              <div className="designed-by w-100 ">
                <div className="row justify-content-center justify-content-lg-end">
                  <div className="col-auto designed-col d-flex justify-content-center  justify-content-sm-end">
                    <div
                      className="designed-by-div"
                      dangerouslySetInnerHTML={{
                        __html:
                          generalDataGlobal[0]?.footer_settings.designed_by,
                      }}
                    ></div>
                  </div>
                  <div className="col-auto designed-col d-flex  justify-content-center justify-content-sm-end">
                    <p>
                      {generalDataGlobal[0]?.footer_settings.rights.replace(
                        "%%year%%",
                        new Date().getFullYear()
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {popup ? (
        <div className="terms-popup">
          <div
            className="terms-content"
            style={{ maxHeight: popupHeight ? popupHeight : "" }}
          >
            <div
              className="container privacy-title-container"
              style={{ paddingRight: 0, paddingLeft: 0 }}
            >
              <div className="row terms-row">
                <div
                  className={"col-12 terms-title-container first"}
                  // onClick={() => {
                  //   setActive(0);
                  // }}
                >
                  <div>
                    <h1
                      className={
                        "terms-title privacy" + (active === 0 ? " active" : "")
                      }
                    >
                      {generalDataGlobal[0]?.popup.title}
                    </h1>
                  </div>
                </div>
                {/* <div
                  className="col-6 terms-title-container second"
                  // onClick={() => setActive(1)}
                  // onClick={() => handleTransition()}
                >
                  <h1
                    className={
                      "terms-title terms" +
                      (active === 1 ? " active-terms" : "")
                    }
                  >
                    {generalDataGlobal[0]?.popup.terms_title}
                  </h1>
                </div> */}
              </div>
              <div className="border-terms conditions first">
                {/* <div
                  className="one"
                  style={{ left: active === 0 ? "0" : "50%" }}
                ></div> */}
              </div>
            </div>

            {/* {active === 0 ? ( */}
              <>
                <div className="container privacy-title">
                  <div className="row ">
                    {/* <div className="col-12 d-flex justify-content-center privacy-subtitle">
                      <h1>
                        {generalDataGlobal[0]?.popup.privacy_content_title}
                      </h1>
                    </div> */}
                    <div className="col-12">
                      {/* <div
                        className="privacy-content test"
                        dangerouslySetInnerHTML={{
                          __html:
                            generalDataGlobal[0]?.popup.privacy_description,
                        }}
                      ></div> */}
                      <p className="privacy-content test mt-lg-5 mt-4">{generalDataGlobal[0]?.popup.description}</p>
                    </div>
                  </div>
                </div>
              </>
             {/* ) : ( */}
              {/* <>
                <div className="container scrollable-container"> */}
                  {/* {generalDataGlobal[0]?.terms.map((term, index) => (
                    <>
                      {index > 0 ? (
                        <div className="border-terms conditions"></div>
                      ) : null}
                      <div key={index} className="row conditions-row">
                        <div className="col-12">
                          <div className="privacy-title conditions">
                            <h1 className="conditions-h1">{term.title}</h1>
                          </div>
                        </div>
                        <div className="col-12">
                          <div
                            className={"privacy-content conditions" + (index === generalDataGlobal[0].terms.length - 1 ? " last" : "")}
                            dangerouslySetInnerHTML={{
                              __html: term.description,
                            }}
                          ></div>
                        </div>
                      </div>
                    </>
                  ))} */}

                  {/* <div
                    className="row conditions-row"
                    dangerouslySetInnerHTML={{
                      __html: generalDataGlobal[0]?.popup.terms,
                    }}
                  ></div>
                </div>
              </>
            )} */}
            <div
              className={
                "buttons-container" +
                (active === 0
                  ? " d-flex justify-content-between align-items-center"
                  : "")
              }
            >
              <div
                className="accept-btn-container"
                style={{ marginTop: active === 1 ? "20px" : "" }}
                onClick={() => (
                  // eslint-disable-next-line
                  setPopup(false),
                  sessionStorage.setItem("lta-first-visit", false),
                  handleCTA(generalDataGlobal[0]?.popup?.url)
                )}
              >
                <button className="accept-button">
                  {" "}
                  {generalDataGlobal[0]?.popup.label}{" "}
                </button>
              </div>
              {/* <div
                className={
                  "next-btn-container" + (active === 1 ? " d-none" : "")
                }
                onClick={() => handleTransition()}
              >
                <p className="next-button">
                  {generalDataGlobal[0]?.popup.next}
                </p>
              </div> */}
            </div>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};
export default Layout;
